var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaratRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05914 15.9608C6.95983 15.9191 6.87511 15.8489 6.81564 15.7591C6.75617 15.6693 6.72461 15.5639 6.72495 15.4561L6.72495 4.54386C6.72461 4.43614 6.75617 4.33073 6.81564 4.24092C6.87511 4.1511 6.95983 4.0809 7.05914 4.03916C7.15992 3.99985 7.26977 3.98988 7.37598 4.0104C7.48219 4.03092 7.58043 4.08109 7.65931 4.15511L13.1155 9.61125C13.2179 9.71469 13.2754 9.8544 13.2754 10C13.2754 10.1456 13.2179 10.2853 13.1155 10.3888L7.65931 15.8449C7.58042 15.9189 7.48219 15.9691 7.37598 15.9896C7.26977 16.0101 7.15992 16.0001 7.05914 15.9608Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaratRight);
export default __webpack_public_path__ + "static/media/carat-right.431ae7085f23c1c935d79872d1fcbab7.svg";
export { ForwardRef as ReactComponent };